(()=>{
 const scriptUrl=document.currentScript?.src||'';
 const productHeroAssets={
   '/products/cepillo-vapor-mascotas':'lifestore-product-pet-ai.webp',
   '/products/cepillo-deslanador-quitapelos-para-perros-y-gatos':'lifestore-product-deslanador-ai.webp',
   '/products/pack-de-2-guantes-quitapelos-reutilizables':'lifestore-product-gloves-ai.webp',
   '/products/cepillo-electrico-inalambrico-4-en-1':'lifestore-product-electric-ai.webp',
   '/products/fuente-bebedero-para-mascotas-blanco':'lifestore-product-fountain-ai.webp',
   '/products/kit-limpieza-48-lavadora-y-4-desagues':'lifestore-product-kit-ai.webp'
 };
 const applyProductHero=()=>{
   const assetName=productHeroAssets[location.pathname.replace(/\/$/,'')];
   const gallery=document.querySelector('.product-information__media media-gallery');
   if(!assetName||!gallery||gallery.dataset.lsHeroApplied==='true'||!scriptUrl)return;
   const assetUrl=new URL(assetName,scriptUrl).href;
   const images=[gallery.querySelector('slideshow-slide:first-of-type img'),gallery.querySelector('.slideshow-controls__thumbnail:first-of-type img')].filter(Boolean);
   if(!images.length)return;
   gallery.dataset.lsHeroApplied='true';
   images.forEach(img=>{img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=assetUrl;img.alt=document.querySelector('.product-details h1')?.textContent?.trim()||img.alt});
 };
 const selectOneUnitByDefault=()=>{
   const form=document.querySelector('#es-form');
   if(!form||form.dataset.lsDefaultQuantitySet==='true')return;
   const offers=form.querySelectorAll('.es-qo-container');
   if(offers.length<2)return;
   form.dataset.lsDefaultQuantitySet='true';
   if(offers[0].getAttribute('offer-selected')!=='true')offers[0].click();
 };
 const showBrandedConfirmation=()=>{
   if(document.querySelector('.ls-order-success'))return;
   const main=document.querySelector('#MainContent')||document.querySelector('main');
   if(!main)return;
   const confirmation=document.createElement('section');
   confirmation.className='ls-order-success';
   confirmation.tabIndex=-1;
   confirmation.setAttribute('role','status');
   confirmation.setAttribute('aria-live','polite');
   confirmation.innerHTML=`
     <div class="ls-order-success__check" aria-hidden="true">✓</div>
     <p class="ls-order-success__eyebrow">PEDIDO RECIBIDO</p>
     <h1>¡Gracias! Ya recibimos tu pedido.</h1>
     <p class="ls-order-success__lead">Revisaremos tus datos y te contactaremos al número indicado para confirmar el despacho.</p>
     <ol class="ls-order-success__steps" aria-label="Próximos pasos">
       <li><b>1</b><span><strong>Confirmación</strong><small>Recibirás nuestro contacto para validar tus datos.</small></span></li>
       <li><b>2</b><span><strong>Preparación</strong><small>Preparamos tu compra para el despacho.</small></span></li>
       <li><b>3</b><span><strong>Seguimiento</strong><small>Podrás revisar el avance de tu envío.</small></span></li>
     </ol>
     <p class="ls-order-success__notice"><strong>No necesitas enviar nuevamente el pedido.</strong> No realizaste ningún pago por adelantado: pagarás cuando lo recibas.</p>
     <div class="ls-order-success__actions"><a href="/collections/all">Seguir comprando</a><a href="/pages/seguimiento">Cómo hacer seguimiento</a><a href="/pages/contact">Corregir un dato o pedir ayuda</a></div>`;
   main.querySelector('.product-information')?.setAttribute('hidden','');
   main.querySelector('.cod-story')?.setAttribute('hidden','');
   main.querySelector('.lifestore-recommendations')?.setAttribute('hidden','');
   document.querySelector('.ls-mobile-buy')?.setAttribute('hidden','');
   main.prepend(confirmation);
   confirmation.focus({preventScroll:true});
   confirmation.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
 };
 const detectSuccessfulOrder=()=>{
   if(document.querySelector('.ls-order-success'))return;
   const appScopes=[...document.querySelectorAll('[data-ls-order-host],#es-form-container,#es-form,[id*="easysell" i],[class*="easysell" i],[class*="easy-sell" i]')];
   const successText=/gracias por tu (?:compra|pedido)|pedido (?:recibido|confirmado|realizado|creado)|order (?:received|confirmed)|thank you for your order/i;
   const successSelector='[data-success="true"],.alert-success,[class*="order-success" i],[class*="thank-you" i],[class*="thankyou" i]';
   const detected=appScopes.some(scope=>scope.matches(successSelector)||scope.querySelector(successSelector)||successText.test(scope.textContent||''));
   if(detected)showBrandedConfirmation();
 };
 const polishEasySellSticky=()=>{
   const controls=[...document.querySelectorAll('button,a,[role="button"]')].filter(el=>/confirmar pedido/i.test(el.textContent||''));
   controls.forEach(control=>{
     control.classList.add('ls-app-sticky-button');
     let host=control;
     while(host.parentElement&&host.parentElement!==document.body){
       host.classList.add('ls-app-sticky-layer');
       const position=getComputedStyle(host).position;
       if(position==='fixed'||position==='sticky')break;
       host=host.parentElement;
     }
     if(getComputedStyle(host).position==='fixed'||getComputedStyle(host).position==='sticky'){
       host.classList.add('ls-app-sticky-layer','ls-app-sticky-cta');
     }
   });
 };
 const curateGallery=()=>{
   const imageKey=img=>{
     if(!img)return '';
     try{return new URL(img.currentSrc||img.src,location.href).pathname.replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|\d+x\d+)(?=\.[a-z]+$)/i,'')}
     catch{return img.currentSrc||img.src||''}
   };
   document.querySelectorAll('.product-information__media .slideshow-controls__thumbnails,.dialog-thumbnails-list').forEach(group=>{
     const seen=new Set();let visible=0;
     group.querySelectorAll('.slideshow-controls__thumbnail,.dialog-thumbnails-list__thumbnail').forEach(button=>{
       const key=imageKey(button.querySelector('img'));
       const hide=!key||seen.has(key)||visible>=5;
       button.hidden=hide;
       button.toggleAttribute('aria-hidden',hide);
       if(!hide){seen.add(key);visible+=1}
     });
   });
 };
 const clarifyOffers=()=>{
   const labels=['IDEAL PARA PROBAR','MÁS ELEGIDO','MAYOR AHORRO','PARA VARIAS MASCOTAS'];
   document.querySelectorAll('#es-form .es-qo-container').forEach((offer,index)=>{
     if(offer.querySelector('.ls-offer-tag'))return;
     const tag=document.createElement('span');
     tag.className='ls-offer-tag';
     tag.textContent=labels[index]||`OPCIÓN ${index+1}`;
     offer.prepend(tag);
   });
 };
 const polishGloveProduct=()=>{
   if(location.pathname.replace(/\/$/,'')!=='/products/guante-removedor-de-pelo-2-en-1-negro')return;
   const offerNames=['1 Guante Quitapelos','Pack Dúo · 2 Guantes','Pack Ahorro · 3 Guantes','Pack Familiar · 4 Guantes'];
   document.querySelectorAll('#es-form .offer-title').forEach((title,index)=>{
     if(offerNames[index]&&title.textContent.trim()!==offerNames[index])title.textContent=offerNames[index];
   });
   document.querySelectorAll('.jdgm-prev-badge__text').forEach(label=>{
     const copy='5.0 estrellas';
     if(label.textContent.trim()!==copy)label.textContent=copy;
   });
 };
 const arrangeCardPayment=()=>{
   document.querySelectorAll('.ls-card-payment').forEach(card=>{
     const easySell=card.closest('.buy-buttons-block')?.querySelector('#easysell');
     if(easySell&&easySell.nextElementSibling!==card)easySell.after(card);
   });
 };
 const selectedCardOffer=host=>{
   const offer=host?.querySelector('#es-form .es-qo-container[offer-selected="true"]')||host?.querySelector('#es-form .es-qo-container');
   const quantityText=offer?.querySelector('.offer-title')?.textContent||offer?.textContent||'1';
   const quantity=Math.max(1,Number(quantityText.match(/\d+/)?.[0]||1));
   const total=offer?.querySelector('.es-price-container .es-o-p')?.textContent?.trim()||'';
   return {quantity,total,discountCode:quantity>=3?'LIFESTORE3':quantity>=2?'LIFESTORE2':''};
 };
 const syncCardOffer=()=>{
   document.querySelectorAll('.ls-card-payment').forEach(card=>{
     const {quantity,total}=selectedCardOffer(card.closest('.buy-buttons-block'));
     const selection=card.querySelector('.ls-card-payment__selection');
     const copy=`${quantity} ${quantity===1?'unidad':'unidades'}${total?` · ${total}`:''} · envío gratis incluido.`;
     if(selection&&selection.textContent!==copy)selection.textContent=copy;
   });
 };
 const checkoutWithCard=async button=>{
   if(button.disabled)return;
   const host=button.closest('.buy-buttons-block');
   const variantId=host?.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value;
   const {quantity,discountCode}=selectedCardOffer(host);
   const status=button.closest('.ls-card-payment')?.querySelector('.ls-card-payment__status');
   if(!variantId){if(status)status.textContent='No pudimos seleccionar el producto. Actualiza la página e inténtalo nuevamente.';return}
   const original=button.querySelector('span')?.textContent||'Pagar con débito o crédito';
   button.disabled=true;
   button.setAttribute('aria-busy','true');
   if(button.querySelector('span'))button.querySelector('span').textContent='Preparando pago seguro…';
   if(status)status.textContent='';
   try{
     const headers={'Content-Type':'application/json','Accept':'application/json'};
     const cartResponse=await fetch('/cart.js',{headers:{'Accept':'application/json'}});
     if(!cartResponse.ok)throw new Error('cart-read-failed');
     const cart=await cartResponse.json();
     const existing=cart.items?.find(item=>String(item.variant_id)===String(variantId));
     const response=await fetch(existing?'/cart/change.js':'/cart/add.js',{
       method:'POST',headers,
       body:JSON.stringify(existing?{id:existing.key,quantity}:{items:[{id:Number(variantId),quantity}]})
     });
     if(!response.ok)throw new Error('cart-update-failed');
     location.assign(discountCode?`/discount/${discountCode}?redirect=/checkout`:'/checkout');
   }catch(error){
     button.disabled=false;
     button.removeAttribute('aria-busy');
     if(button.querySelector('span'))button.querySelector('span').textContent=original;
     if(status)status.textContent='No pudimos abrir el pago. Inténtalo nuevamente o elige pago al recibir.';
   }
 };
 const createMobileAccordions=()=>{
   if(!matchMedia('(max-width: 749px)').matches)return;
   const fold=(target,title)=>{
     if(!target||target.closest('.ls-mobile-story-fold'))return;
     const details=document.createElement('details');
     details.className='ls-mobile-story-fold page-width';
     const summary=document.createElement('summary');
     summary.innerHTML=`<span>${title}</span><b aria-hidden="true">+</b>`;
     const body=document.createElement('div');
     body.className='ls-mobile-story-fold__body';
     target.before(details);details.append(summary,body);body.append(target);
     const viewport=matchMedia('(max-width: 749px)');
     const syncViewport=()=>{details.open=!viewport.matches};
     viewport.addEventListener?.('change',syncViewport);
   };
   fold(document.querySelector('.cod-story__intro'),'Descripción y beneficios');
   fold(document.querySelector('.ls-explainer'),'Uso, contenido y detalles');
 };
 const simplify=()=>{
 applyProductHero();
 const root=document.body;
 if(root){
 const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
 const nodes=[];while(walker.nextNode())nodes.push(walker.currentNode);
 nodes.forEach(node=>{
 if(node.parentElement.closest('script,style,textarea,input'))return;
 const before=node.nodeValue;
 const after=before.replace(/ENVÍO GRATIS A TODO CHILE/g,'ENVÍO GRATIS DENTRO DE NUESTRA COBERTURA').replace(/Envío gratis a todo Chile/g,'Envío gratis dentro de nuestra cobertura').replace(/Envío a todo Chile/g,'Envío dentro de nuestra cobertura').replace(/\$\s*(\d{1,3}(?:,\d{3})+)(?!\d)/g,(_,amount)=>'$'+amount.replace(/,/g,'.'));
 if(after!==before)node.nodeValue=after;
 });
 }
document.querySelectorAll('#es-form .offer-title').forEach(title=>{
 const before=title.textContent;
 const after=before.replace(/\s*[—–-]\s*Más vendido/gi,'').replace(/\s*[—–-]\s*Máximo ahorro/gi,'');
 if(before!==after)title.textContent=after;
 });
 document.querySelectorAll('#es-form-button .es-total-placeholder').forEach(amount=>{
   if(!amount.textContent.trim())amount.textContent='Calculando total…';
 });
 selectOneUnitByDefault();
 clarifyOffers();
 polishGloveProduct();
 arrangeCardPayment();
 syncCardOffer();
 curateGallery();
 createMobileAccordions();
 polishEasySellSticky();
 detectSuccessfulOrder();
   const form=document.querySelector('#es-form');
   if(form&&!form.dataset.lsMobileSections){
     form.parentElement?.setAttribute('data-ls-order-host','');
     form.dataset.lsMobileSections='true';
     const firstName=form.querySelector('.es-first_name-group');
     const address=form.querySelector('.es-address-group');
     if(firstName){const label=document.createElement('p');label.className='ls-form-section ls-form-section--customer';label.textContent='Tus datos';firstName.before(label)}
     if(address){const label=document.createElement('p');label.className='ls-form-section ls-form-section--delivery';label.textContent='Dirección de entrega';address.before(label)}
   }
 };
 document.addEventListener('click',event=>{
   const button=event.target.closest?.('[data-ls-card-checkout]');
   if(button){event.preventDefault();checkoutWithCard(button)}
 });
 const observer=new MutationObserver(simplify);
 observer.observe(document.body,{childList:true,subtree:true});simplify();
 window.addEventListener('easysell:order-success',showBrandedConfirmation);
})();
